import { Injectable } from '@angular/core';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import  jwtDecode from 'jwt-decode';
import { Subject, Observable, of, } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import * as _moment from 'moment';
import { IFlightSearchRequest } from '../models/request/IRequest';
import { REGEX } from '../constants/regex';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from './data.service';
import { InvalidCredentialsComponent } from '../components/invalid-credentials/invalid-credentials.component';
import { ApiConfig } from '../config/api.config';
@Injectable({
  providedIn: 'root'
})

export class UtilityService {

  flightSearchRequest: IFlightSearchRequest;
  name: any;
  insuranceData: any;
  showInvalidCredentials = false;
  constructor(
    public router: Router,
    private snackbar: MatSnackBar,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    private dataService:  DataService,
    private dialog: MatDialog, // don't remove this fb here it is used by other component with bind this
  ) { this.setTokenData(); }

  tokenData;
  refresh$ = new Subject();

  getTokenData() {
    return this.tokenData;
  }

  setTokenData() {
    this.tokenData = localStorage.getItem('token') ? jwtDecode(localStorage.getItem('token')) : null;
  }

  getUser() {return this.tokenData = localStorage.getItem('user_name',)}
  // getUserSurname() {return this.tokenData = localStorage.getItem('user_surname',)}

  clearLogin() {
    this.tokenData = null;
  }
  initDisabledControl(val = null) {
    const control = new FormControl(val);
    control.disable();
    return control;
  }
  toBoolean(val): boolean {
    if (val === true || val === 'true' || val === 'active' || val === 1 || val === '1') {
      return true;
    } else { return false; }
  }
  toOneZero(val): string {
    if (val === true || val === 'true' || val === 'active' || val === 1 || val === '1') {
      return '1';
    } else { return '0'; }
  }
  toYesNo(val) {
    const check = this.toBoolean(val);
    if (check) { return 'Yes'; }
    return 'No';
  }
  // Evaluate total from the values in a group
  evaluateGroupTotal(group: FormGroup) {
    const values = Object.values(group.value);
    return values.map(val => Number(val ? val : 0)).reduce((acc, value) => acc + Number(value ? value : 0), 0);
  }
  // Evaluate total from given controls
  evaluateControlTotal(controls: FormControl[]) {
    return controls.map(c => Number(c.value ? c.value : 0)).reduce((acc, value) => acc + Number(value ? value : 0), 0);
  }

  evaluateSum(input: Array<any>) {
    const arr = input.map(i => Number(typeof (i) === 'number' ? i : parseInt(i, 10)));
    return arr.map(val => Number(val ? val : 0)).reduce((acc, value) => acc + Number(value ? value : 0), 0);
  }

  nullCheckObj(obj) {
    const newObj: any = {};
    for (const [key, value] of Object.entries(obj)) {
      if (obj[key] !== null && obj[key] !== undefined && obj[key] !== 'null' && obj[key] !== 'undefined' && obj[key] !== '' && obj[key] !== 'NA') {
        newObj[key] = value;
      }
    }
    return newObj;
  }

  isEmptyObject(obj) {
    if (!Object.getOwnPropertySymbols(obj).length && !Object.getOwnPropertyNames(obj).length) {
      return true;
    }
    return false;
  }

  removeValidations(control: FormControl | AbstractControl) {
    control.clearValidators();
    control.updateValueAndValidity();
  }
  setControlsRequired(controls: FormControl[] | AbstractControl[]) {
    controls.forEach(control => {
      control.enable();
      control.setValidators(Validators.required);
      control.updateValueAndValidity();
    });
  }
  removeRequired(controls: FormControl[] | AbstractControl[]) {
    controls.forEach(control => {
      control.clearValidators();
      control.updateValueAndValidity();
    });
  }
  enableControls(control: FormControl[] | AbstractControl[]) { control.forEach(i => i.enable()); }
  disableControls(control: FormControl[] | AbstractControl[]) { control.forEach(i => i.disable()); }

  setFormArrayValue(arr: FormArray, initGroup, data: Array<any>) {
    for (let i = 1; i <= data.length - 1; i++) {
      arr.push(initGroup());
    }
    arr.patchValue(data);
  }

  findInvalidControls(form: FormGroup | FormArray) {
    const invalid = [];
    for (const i in form.controls) {
      if (form.controls[i] instanceof FormArray) {
        const arr: FormGroup = form.controls[i].controls;
        for (const group in arr) {
          if (arr[group].invalid) {
            // FIXME not working with nested formArrays...
            this.findInvalidControls(arr[group]);
          }
        }
      } else {
        const controls = form.controls;
        if (controls[i].invalid) { invalid.push(i); }
      }
    }
    return invalid;
  }
  scrollToError(): void {
    const firstElementWithError = document.querySelectorAll('.ng-invalid');
    this.scrollTo(firstElementWithError[1]);
  }
  private scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  setAsTouched(group: FormGroup | FormArray) {
    group.markAsTouched();
    for (const i in group.controls) {
      if (group.controls[i] instanceof FormControl) {
        group.controls[i].markAsTouched();
      } else {
        this.setAsTouched(group.controls[i]);
      }
    }
  }

  clearFormArray(arr: FormArray) { while (arr.length !== 0) { arr.removeAt(0); } }

  getLastNyears(date: Date, n: number) {
    const years = [];
    for (let i = 0; i < n; i++) {
      years.push(new Date(date.getFullYear() - i, date.getMonth()).getFullYear());
    }
    return years;
  }

  getNextNyears(date: Date, n: number) {
    const years = [];
    for (let i = 0; i < n; i++) {
      years.push(new Date(date.getFullYear() + i, date.getMonth()).getFullYear());
    }
    return years;
  }

  getLastNmonths(date: Date, n: number) {
    const formatter = new Intl.DateTimeFormat('default', { month: 'long' });
    const months = [];
    for (let i = 0; i < n; i++) {
      months.push(formatter.format(new Date(date.getFullYear(), date.getMonth() - i)));
    }
    return months;
  }
  getMonthOptions() {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat('default', { month: 'long' });
    const months = [];
    for (let i = 0; i < 12; i++) {
      months.push({ month: i, name: formatter.format(new Date(date.getFullYear(), i)) });
    }
    return months;
  }

  daysInMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  getMonthName(date: Date) {
    const formatter = new Intl.DateTimeFormat('default', { month: 'long' });
    const month = formatter.format(new Date(date.getFullYear(), date.getMonth()));
    return month;
  }

  isoString(val) {
    if (val !== '') { return new Date(val).toISOString(); }
    return '';
  }
  timeStamp(val) {
    if (val !== '') { return new Date(val).getTime(); }
    return '';
  }
  setDate(val) {
    if (val && (val !== '' || val !== null || val !== undefined || val !== 'undefined' || val !== 'null' || val !== NaN || val !== 'NaN')) {
      return new Date(parseInt(val, 10));
    }
    return '';
  }

  isRequired(abstractControl: AbstractControl) {
    if (abstractControl?.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator['required']) { return true; }
    }
    return false;
  }

  errorMessage(err) {
    if (err instanceof HttpErrorResponse) {
      const message = err.error?.message || err.error?.message;
      if ((err.error !== 200 || err.status === 401) && err.error.message) {
        if (
          message === 'Invalid username or JWT token' ||
          message === 'Invalid token unauthorised access.' ||
          message === 'jwt malformed' ||
          message === 'Invalid Credentials'
        ) {
          setTimeout(() => {
            localStorage.removeItem('FlightLoginToken');
            localStorage.removeItem('passengerDetail');
            localStorage.removeItem('Auth_Key');
            localStorage.removeItem('user_name');
            localStorage.removeItem('Flight_User_Details');
            this.router.navigateByUrl('/');
            // this.showMsg('Login to Continue', '');
          }, 2000);
          // this.showMsg('Your Session has Expired', ''); 
          // Set flag and show dialog
          this.showInvalidCredentials = true;
          if (this.showInvalidCredentials) {
            this.dialog.open(InvalidCredentialsComponent, {
              disableClose: true // This prevents closing the dialog on outside click or escape key press
            });
          };
        } else {
          if (message) {
            return this.showMsg(message, 'Error');
          }
        }
        return message;
      } else if (err.status === 0) {
        // this.router.navigateByUrl('/')
        this.showMsg('Looks like you are not connected.....', '');
        return setTimeout(() => {
          this.showMsg('Please check your connection.....', '');
        }, 5000);
      }
      if (message) {
        return this.showError(message);
      } else {
        this.showError('Currently system is busy, kindly try again later.', '');
      }
    }
  }

  showMsg(msg: string, type: string = 'Success', duration = 5500) {
    // this.snackbar.open(msg, type, { duration });
  }
  showError(msg: string = 'Something Went Wrong', type: string = 'Error', duration = 5500) {
    // this.snackbar.open(msg, type, { duration });
  }

  getApiRequestCredentials() {
    return {
      ...ApiConfig.credentials,  // baseUrl: ApiConfig.baseUrl,
    };
  }

  formatDate(date, format: string) {
    return date ? _moment(date).format(format) : "";
  }

  getTimeDifference(startDate: string, startTime: string, endDate: string, endTime: string) {
    const sTime = _moment(`${startDate} ${startTime}`);
    const eTime = _moment(`${endDate} ${endTime}`);
    return `${_moment.utc(eTime.diff(sTime)).format('H:mm')}`.replace(':', 'h ').concat('m');
  }

  getRoleByUrl(name) {
    const roles = [
      { id: 1, name: 'Flight', role: 'flights', value: 'flight' },
      { id: 2, name: 'Hotel', role: 'hotel', value: 'hotel'},
      { id: 3, name: 'Trains', role: 'trains', value: 'trains'},
      { id: 4, name: 'Buses', role: 'buses', value: 'buses'},
      { id: 5, name: 'Outstation', role: 'outstation', value: 'outstation'},
      { id: 6, name: 'Visa', role: 'visa', value: 'visa'},
    ];
    return roles ? roles.find(i => i.id === name)?.role : null;
  }

  getCardType(cardNumber: string): string {
    // debugger
    let cardType: string = '';
    const cardRegex = REGEX.CARDTYPE;
    if(cardRegex.toString() !== '{}') {
      for (let index = 0; index < Object.keys(cardRegex).length; index++) {
        if(new RegExp(cardRegex[Object.keys(cardRegex)[index]]).test(cardNumber)) {
          cardType = Object.keys(cardRegex)[index].toLowerCase()
          break;
        } else {
          cardType = ''
        }
      }
    } else {
      cardType = ''
    }
    return cardType;
  }


  confirm(head: string, body: string, rest: any = {}): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: rest.width ? rest.width : '450px', data: { head, body, ...rest }
    });
    return dialogRef.afterClosed();
  }

  confirmDelete(rest = {}, head = 'Confirm Delete', msg = 'Are you sure you want to delete ## ?'): Observable<any> {
    return this.confirm(head, msg, { ...rest, delete: true });
  }
  actionDialog(rest = {}, head, msg): Observable<any> {
    return this.confirm(head, msg, { ...rest });
  }

  transfromTimeToHourMin(time: string) {
    const timeArr = time?.split(':');
    if (timeArr && timeArr.length > 2) {
      return `${timeArr[0]}:${timeArr[1]}`;
    }
    return time;
  }

  logOutUser() {
    localStorage.removeItem('Auth_Key');
    localStorage.removeItem('user_name');
    localStorage.removeItem('Hotel_Auth_Key');
    localStorage.removeItem('Flight_User_Detiles');
    localStorage.removeItem('User_detiles');
    this.router.navigateByUrl('/');
    // this.showMsg('Successfully Logout')
  }

  transformObjectToQueryParam(reqObject: any) {
    const str = [];
    for (var obj in reqObject)
    if (reqObject.hasOwnProperty(obj)) {
      str.push((obj) + "=" + (reqObject[obj]));
    }
    return str.join("&");
  }

  encodeObjectToUrlParams(obj: any): string {
    const jsonString = JSON.stringify(obj);
    return encodeURIComponent(jsonString);
  }

  decodeUrlParamsToObject(urlParams: string): any {
    const jsonString = decodeURIComponent(urlParams);
    return JSON.parse(jsonString);
  }
  
  encodeDeepLinkHash(text: string) {
    return encodeURIComponent(text);
  }

  decodeDeepLinkHash(text: string) {
    return decodeURIComponent(text);
  }

  getQueryParamsFromUrl(url: string): any {
    return Object.fromEntries((new URLSearchParams(url) as any).entries());
  }

  convertSecondsToTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours} h, ${remainingMinutes} m`;
  }

  pushInsurance(data: any) {
    this.insuranceData = data;
  }

  getInsurance() {
    return this.insuranceData;
  }
  
  convertToNumber(value: any): number {
    if (typeof value === 'number') {
      return value;
    } else {
      // Handle conversion to number based on your logic
      return parseInt(value, 10); // Example: converting string to number
    }
  }

  // Method to get an array of years from the current year to 12 years in the future
  getYearsFromCurrent(): number[] {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 13 }, (_, i) => currentYear + i);
  }

  convertToTitleCase(str: string): string {
    return str
      .split('_') // Split the string into an array by underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(' '); // Join the array back into a string with spaces
  }

  filterMeals(mealList: any[], filterTypes: string[]): any[] {
    if (!filterTypes.length) return mealList;

    return mealList.filter(item => {
      if (filterTypes.includes('0') && item.is_veg === true) return true;
      if (filterTypes.includes('1') && item.is_veg === false) return true;
      if (filterTypes.includes('2') && item.is_veg === null) return true;
      return false;
    });
  }

  isDesktopView(): boolean {
    return window.innerWidth > 1024; // Example: Adjust the breakpoint as needed
  }

  istabletView(): boolean {
    return window.innerWidth > 788; // Example: Adjust the breakpoint as needed
  }

  getCheapFlights(): string {
    const result = "cheap-flights";
    return result;
  }
}
